/*
 * Site-wide smooth scroll, matching shed.design's own behaviour — confirmed
 * live (Sep 2026) by the "lenis" class shed.design puts on <html>, not
 * guessed. Loaded once here, globally, for every page/template, not scoped
 * to the Shed-referenced sections only: this is scroll physics for the
 * whole site, not a per-component effect.
 *
 * Exposes window.hsLenis so other scripts (e.g. header-utility-watch.js's
 * "back to top" click) can call hsLenis.scrollTo(...) instead of the native
 * window.scrollTo — running both at once fights over the same scroll
 * animation and stutters.
 *
 * Respects prefers-reduced-motion: users who've asked for reduced motion
 * get plain native scrolling, no inertia, same as every other animation on
 * this site.
 */
(function () {
  if (window.hsLenis || window.HSLenisInit) return;
  window.HSLenisInit = true;

  if (typeof Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var lenis = new Lenis({
    autoRaf: false
  });
  window.hsLenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // The theme editor tears down and re-renders sections without a full page
  // reload; a resize/content-height recalculation keeps Lenis's internal
  // scroll-length measurement in sync with the new DOM.
  document.addEventListener('shopify:section:load', function () {
    lenis.resize();
  });
})();
